import { Injectable, ErrorHandler, Injector, inject } from '@angular/core';

import { Logger } from '@app/core/logging/logger';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private injector = inject(Injector);
  private logger: Logger | null = null;

  handleError(err: unknown): void {
    const logger = this.getLogger();

    if (logger) {
      logger.error(err instanceof Error && (err as any).originalError ? (err as any).originalError : err);
    } else {
      console.warn('GlobalErrorHandler: Logger instance not available.');
    }
  }

  private getLogger(): Logger | null {
    if (this.logger) {
      return this.logger;
    }

    try {
      this.logger = this.injector.get(Logger);
    } catch {
      this.logger = null;
    }

    return this.logger;
  }
}
